import { reportConstants } from "../constants";

const initialState = {
  execReportsPipelines: Array(21).fill(null),
  selectedExecReports: [],
  activeTab: "1",
  modalAddReportWizard: false,
  selectedNewReportCustomer: null,
  selectedReport: "",
  selectedReportId: "",
  selectedReportEdit: {},
  selectedReportEditIsActive: false,
  selectedReportEditIsInternalUse: false,
  defaultReportPage: "/exec-reports",
  handleGridReloadCallBack: null,
};

export function reports(state = initialState, action) {
  switch (action.type) {
    case reportConstants.SET_HANDLE_GRID_RELOAD_CALLBACK:
      return {
        ...state,
        handleGridReloadCallBack: action.handleGridReloadCallBack,
      };

    case reportConstants.SET_DEFAULT_REPORT_PAGE:
      return { ...state, defaultReportPage: action.defaultReportPage };

    case reportConstants.SET_SELECTED_REPORT_EDIT:
      return { ...state, selectedReportEdit: action.selectedReportEdit };
    case reportConstants.SET_SELECTED_REPORT_EDIT_IS_ACTIVE:
      return {
        ...state,
        selectedReportEditIsActive: action.selectedReportEditIsActive,
      };
    case reportConstants.SET_SELECTED_REPORT_EDIT_IS_INTERNAL_USE:
      return {
        ...state,
        selectedReportEditIsInternalUse: action.selectedReportEditIsInternalUse,
      };
    case reportConstants.SET_SELECTED_NEW_REPORT_CUSTOMER:
      return { ...state, selectedNewReportCustomer: action.selectedNewReportCustomer };

    case reportConstants.TOGGLE_WIZARD_SELECTED_REPORT:
      return { ...state, selectedReport: action.selectedReport };
    case reportConstants.TOGGLE_WIZARD_SELECTED_REPORT_ID:
      return { ...state, selectedReportId: action.selectedReportId };
    case reportConstants.TOGGLE_MODAL_ADD_REPORT_WIZARD:
      return { ...state, modalAddReportWizard: action.modalAddReportWizard };
    case reportConstants.TOGGLE_REPORTS_ACTIVE_TAB:
      return { ...state, activeTab: action.tab };
    case reportConstants.TOGGLE_EXEC_REPORTS_SELECT_ALL:
      if (
        state.selectedExecReports &&
        action.pageItemCount > 0 &&
        state.selectedExecReports.length < action.pageItemCount
      ) {
        var _allExecReports = [];
        if (state.executedReports && state.executedReports.length) {
          state.executedReports.forEach((item) =>
            _allExecReports.push(item.pipelineInstanceId)
          );
        }
        return { ...state, selectedExecReports: _allExecReports };
      } else {
        return { ...state, selectedExecReports: [] };
      }
    case reportConstants.TOGGLE_EXEC_REPORTS_SELECTION:
      var _selectedExecReports = state.selectedExecReports.slice(0);
      var _index = _selectedExecReports.indexOf(action.pipelineInstanceId);
      if (_index > -1) {
        _selectedExecReports.splice(_index, 1);
      } else {
        _selectedExecReports.push(action.pipelineInstanceId);
      }
      return { ...state, selectedExecReports: _selectedExecReports };

    case reportConstants.GETALL_REQUEST:
      return {
        ...state,
        selectedExecReports: [],
        loading: true,
      };
    case reportConstants.GET_CONFIGUREDREPORTS_REQUEST:
      return {
        ...state,
        selectedExecReports: [],
        loadingConfigReports: true,
      };

    case reportConstants.GET_EXECUTEDREPORTS_SUCCESS:
      return {
        ...state,
        //loading: false,
        executedReports: action.reports,
        ERCount: action.Count,
        ERTotalPages: action.TotalPages,
        ERTotalCount: action.TotalCount,
      };

    case reportConstants.GET_EXECUTEDREPORTS_URI_SUCCESS:
      return {
        ...state,
        //loading: false,
        executedReports: action.reports,
        execReportsFromURIQuery: true,
        ERCount: action.Count,
        ERTotalPages: action.TotalPages,
        ERTotalCount: action.TotalCount,
        execReportsParams: action.params,
      };

    case reportConstants.SET_EXEC_REPORTS_PARAMS:
      var _params = state.execReportsParams || {};
      _params[action.paramName] = action.paramValue;
      return {
        ...state,
        execReportsParams: _params,
      };

    case reportConstants.GET_CONFIGUREDREPORTS_SUCCESS:
      return {
        ...state,
        loadingConfigReports: false,
        loadedConfigReports: true,
        configuredReports: action.reports,
        CRTotalPages: action.TotalPages,
      };

    case reportConstants.GETALL_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.error,
      };
    case reportConstants.GET_CONFIGUREDREPORTS_FAILURE:
      return {
        ...state,
        loadingConfigReports: false,
        loadedConfigReports: true,
        errorConfigReports: action.error,
      };
    case reportConstants.EXPAND_ROW:
      if (state[action.reportsName] && state[action.reportsName].length) {
        let _item = state[action.reportsName][action.rowIndex];
        _item.expanded = !_item.expanded;
      }
      return { ...state };
    case reportConstants.SET_ACTIVE_ROW:
      if (state[action.reportsName] && state[action.reportsName].length) {
        var oldActiveRow = state[action.reportsName].filter(function (obj) {
          return obj.isActive;
        })[0];
        if (oldActiveRow) {
          oldActiveRow.isActive = false;
        }
        let _item = state[action.reportsName][action.rowIndex];
        _item.isActive = true;
      }

      return { ...state };
    case reportConstants.CLEAR_REPORTS:
      return {
        ...initialState,
        cleared: true,
      };
    case reportConstants.RESET_REPORTS_PIPELINES:
      return { ...state, execReportsPipelines: Array(21).fill(null) };

    case reportConstants.UPDATE_REPORTS_PIPELINES:
      var updatedReportsPipelines = state.execReportsPipelines.slice();
      updatedReportsPipelines[action.index] = action.pipelines;
      return { ...state, execReportsPipelines: updatedReportsPipelines };

    default:
      return state;
  }
}
